import InputRecording from './Containers/InputRecordingContainer'

export default InputRecording
